import { render, staticRenderFns } from "./productView.vue?vue&type=template&id=548efcb4"
import script from "./productView.vue?vue&type=script&lang=js"
export * from "./productView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports